export * from './erforderliches-dokuments-list.component';
export * from './erforderliches-dokuments-list.component.module';